import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { DraggableModal } from 'components/flink-components';
import { VideoPlayer } from 'components/common';
import { filesURL } from 'config';
import {
  showParentAdvice,
  setParentAdviceUrl,
  setParentAdviceCoords,
} from 'actions/flinkPlayActions';
import { showGameParentAdvice, showGameMultiplayerAdvice } from 'actions/gameActions';
import { stopAudio } from 'actions/audioActions';

import classes from './ParentAdvice.module.scss';
// import { showError } from 'actions/statusActions';

class ParentAdvice extends Component {
  state = {
    nextLocale: null,
    locale: null,
  };

  componentDidMount() {
    this.setUrl();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      // parentAdviceUrl,
      // isMenuAdviceOpened,
      isGameAdviceOpened,
      isGameMultiplayerAdviceOpened,
      currentActivity,
      currentMenu,
      locale,
      showSettings,
      familyReportsOpened,
      parentAdvicesEnabled,
    } = this.props;

    // if parent advice url is changed and locale is the same then
    // "screen" was changed and need to close dialog
    // if (
    //   prevProps.parentAdviceUrl &&
    //   parentAdviceUrl &&
    //   prevProps.parentAdviceUrl !== parentAdviceUrl &&
    //   prevProps.locale === locale &&
    //   prevState.locale === this.state.locale
    // ) {
    //   console.log(1)
    //   this.closeHandler();
    // }

    if (
      prevState.locale !== this.state.locale ||
      prevProps.locale !== locale ||
      prevProps.showSettings !== showSettings ||
      prevProps.familyReportsOpened !== familyReportsOpened ||
      // prevProps.isMenuAdviceOpened !== isMenuAdviceOpened ||
      prevProps.isGameAdviceOpened !== isGameAdviceOpened ||
      prevProps.isGameMultiplayerAdviceOpened !== isGameMultiplayerAdviceOpened ||
      prevProps.currentMenu !== currentMenu ||
      prevProps.currentActivity !== currentActivity ||
      prevProps.parentAdvicesEnabled !== parentAdvicesEnabled
    ) {
      this.setUrl();
    }
  }

  setUrl = () => {
    const {
      currentActivity,
      currentMenu,
      showSettings,
      configParentVideos,
      familyReportsOpened,
      parentAdvicesEnabled,
      isGameMultiplayerAdviceOpened,
    } = this.props;

    // Check if multiplayer advice is opened
    if (isGameMultiplayerAdviceOpened) {
      // Get settings multi-player video
      const videos = (configParentVideos && configParentVideos.multiplayer) || {};
      return this.setVideos(videos);
    }


    if (!parentAdvicesEnabled) {
      return this.resetHandler();
    }

    // Check if current settings is opened
    if (showSettings) {
      // Get settings parent video
      const videos = (configParentVideos && configParentVideos.settings) || {};
      this.setVideos(videos);
    }

    // Check if family reports is opened
    else if (familyReportsOpened) {
      // Get settings parent video
      const videos =
        (configParentVideos && configParentVideos.familyReports) || {};
      this.setVideos(videos);
    }

    // Check if activity is opened
    else if (currentActivity) {
      const { parentVideos } = currentActivity.template;
      const { parentVideos: gameParentVideos } = currentActivity.data.options;

      this.setVideos(gameParentVideos || parentVideos || {});
    }

    // Check if menu is opened
    else if (currentMenu) {
      this.setVideos(currentMenu.parentVideos || {});
    }
  };

  setVideos = (videos) => {
    const {
      locales,
      parentAdviceUrl,
      setParentAdviceUrl,
      parentAdvicesLocales,
    } = this.props;

    const locale = this.state.locale || this.props.locale;
    const localeCode = (locale && locale.code) ? String(locale.code) : '';
    const availableLocales = [];

    const selectedRaw = Array.isArray(parentAdvicesLocales) ? parentAdvicesLocales : [];
    const selectedSet = new Set(
      selectedRaw
        .map((x) => (x && typeof x === 'object' ? x.code : x))
        .filter(Boolean)
        .map((x) => String(x).toLowerCase()),
    );

    const solutionHasSelectedLocalesForParentAdvice = selectedSet.size > 0;

    const findLocaleObjByCode = (code) => {
      const c = String(code || '').toLowerCase();
      if (!c) return null;
      return (locales || []).find((l) => String(l?.code || '').toLowerCase() === c) || null;
    };

    const getVideoByLocaleCode = (code) => {
      const c = String(code || '');
      if (!c) return null;
      if (videos[c]) return videos[c];
      const k = Object.keys(videos || {}).find((x) => String(x).toLowerCase() === c.toLowerCase());
      return k ? videos[k] : null;
    };

    Object.keys(videos || {}).forEach((key) => {
      const value = videos[key];
      if (!value) return;

      const loc = findLocaleObjByCode(key);
      if (!loc) return;

      if (solutionHasSelectedLocalesForParentAdvice) {
        if (selectedSet.has(String(loc.code).toLowerCase())) {
          availableLocales.push(loc);
        }
      } else if (String(loc.code).toLowerCase() === String(this.props.locale?.code || '').toLowerCase()) {
        availableLocales.push(loc);
      }
    });

    // Pick the best video for current locale; fallback to first available locale if mismatch.
    let parentVideo = getVideoByLocaleCode(localeCode);
    let effectiveLocaleCode = localeCode;

    if (!parentVideo && availableLocales.length) {
      effectiveLocaleCode = String(availableLocales[0].code || '');
      parentVideo = getVideoByLocaleCode(effectiveLocaleCode);
    }

    if (!parentVideo) return this.resetHandler();

    let nextLocale;
    const idxOfLocale = _.findIndex(
      availableLocales,
      (l) => String(l?.code || '').toLowerCase() === String(effectiveLocaleCode || '').toLowerCase(),
    );

    if (availableLocales.length > 1) {
      if (idxOfLocale === availableLocales.length - 1) {
        // last locale
        nextLocale = availableLocales[0];
      } else {
        nextLocale = availableLocales[idxOfLocale + 1];
      }
    }

    const effectiveLocaleObj =
      (this.state.locale && String(this.state.locale.code || '').toLowerCase() === String(effectiveLocaleCode || '').toLowerCase())
        ? this.state.locale
        : findLocaleObjByCode(effectiveLocaleCode) || locale;

    const localeFolder = effectiveLocaleObj?.name || effectiveLocaleObj?.displayName || effectiveLocaleObj?.code || 'en';
    const url = `${filesURL}/Files/animations/ParentVideos/${localeFolder}/${parentVideo}`;

    if (parentAdviceUrl !== url) {
      console.log('[ParentAdvice][url]', {
        effectiveLocaleCode,
        availableLocales: (availableLocales || []).map((l) => l.code),
        nextLocale: nextLocale ? nextLocale.code : null,
        url,
      });
      this.setState({ nextLocale });
      setParentAdviceUrl(url);
    }
  };

  changeLocale = () => {
    this.setState({ locale: this.state.nextLocale });
  };

  errorHandler = () => {
    // this.closeHandler();
  };

  onStartPlay = () => {
    stopAudio();
  };

  resetHandler = () => this.closeHandler(true);

  closeHandler = (resetUrl = false) => {
    const {
      parentAdviceUrl,
      isGameAdviceOpened,
      isGameMultiplayerAdviceOpened,
      isMenuAdviceOpened,
      setParentAdviceUrl,
      showParentAdvice,
      showGameParentAdvice,
      showGameMultiplayerAdvice,
    } = this.props;

    parentAdviceUrl && resetUrl && setParentAdviceUrl('');
    isMenuAdviceOpened && showParentAdvice(null);
    isGameAdviceOpened && showGameParentAdvice(null);
    isGameMultiplayerAdviceOpened && showGameMultiplayerAdvice(null);

    if (resetUrl) {
      this.setState({ locale: null, nextLocale: null });
    }
  };

  debouncedSetParentAdvice = _.debounce(this.props.setParentAdviceCoords, 100);

  render() {
    const {
      parentAdviceUrl,
      isMenuAdviceOpened,
      isGameAdviceOpened,
      isGameMultiplayerAdviceOpened,
      parentAdvicesEnabled,
      parentAdviceCoords,
    } = this.props;

    const { nextLocale } = this.state;

    if (!parentAdvicesEnabled && !isGameMultiplayerAdviceOpened) return null;
    if (!parentAdviceUrl) return null;

    if (!isMenuAdviceOpened && !isGameAdviceOpened && !isGameMultiplayerAdviceOpened) return null;

    return (
      <DraggableModal
        show
        noGutters
        resizable
        size={{ width: '50vmin' }}
        lockAspectRatio
        onClose={() => this.closeHandler()}
        className={classes.wrapper}
        onDrag={(...args) => this.debouncedSetParentAdvice(...args)}
        position={parentAdviceCoords}
      >
        <VideoPlayer
          // ref={this.videoRef}
          playing
          controls
          width="100%"
          height="100%"
          url={parentAdviceUrl}
          onPlay={this.onStartPlay}
          // onReady={() => setLoaded(true)}
          onError={this.errorHandler}
          // onEnded={callback}
        />

        {nextLocale && (
          <button
            className={classes.changeLangButton}
            onClick={this.changeLocale}
          >
            {nextLocale.displayName}
          </button>
        )}
      </DraggableModal>
    );
  }
}

ParentAdvice.propTypes = {
  locales: PropTypes.array.isRequired,
  isMenuAdviceOpened: PropTypes.bool,
  locale: PropTypes.object,
  currentMenu: PropTypes.object,
  showParentAdvice: PropTypes.func.isRequired,
  showGameParentAdvice: PropTypes.func.isRequired,
  setParentAdviceUrl: PropTypes.func.isRequired,
  parentAdviceUrl: PropTypes.string,
  showSettings: PropTypes.bool,
  configParentVideos: PropTypes.object,
  familyReportsOpened: PropTypes.bool,
  parentAdvicesLocales: PropTypes.array,
  // showError: PropTypes.func.isRequired,
};

const mapStateToProps = ({ flinkPlay, game, status, common }) => ({
  locales: common.locales,
  configParentVideos: common.config.parentVideos,
  showSettings: flinkPlay.showSettings,
  parentAdviceCoords: flinkPlay.parentAdviceCoords,
  familyReportsOpened: flinkPlay.familyReportsOpened,
  parentAdviceUrl: flinkPlay.parentAdviceUrl,
  currentActivity: game.currentActivity,
  currentMenu: flinkPlay.currentMenu,
  locale: flinkPlay.solutionLocale || status.lang,
  isMenuAdviceOpened: flinkPlay.parentAdvice,
  isGameAdviceOpened: game.gameParentAdvice,
  isGameMultiplayerAdviceOpened: game.gameMultiplayerAdvice,
  parentAdvicesEnabled:
    (flinkPlay.solution && flinkPlay.solution.parentAdvicesEnabled) ||
    game.isPreview,
  parentAdvicesLocales:
    (flinkPlay.solution && flinkPlay.solution.parentAdvicesLocales) || [],
});

export default connect(mapStateToProps, {
  showParentAdvice,
  showGameParentAdvice,
  showGameMultiplayerAdvice,
  setParentAdviceUrl,
  setParentAdviceCoords,
  // showError
})(ParentAdvice);
